import React from 'react';
import { Box, StepGroup, StepItem } from '@razorpay/blade/components';
import { useWizardInfo } from 'components/WizardViews/providers/WizardInfoProvider';
import useIsFeatureDisabledForRearch from 'access/useIsFeatureDisabledForRearch';
import { getStepMarker } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/utils';
import { revisePaySteps, ReviseSalaryFormData } from '../constants';
import { renderMarker } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/viewHelpers';
import { useFormWithProvider } from 'forms';

const stepsWithMSS = [
  { id: 'update-ctc', title: 'Update CTC', step: revisePaySteps.step1 },
  { id: 'update-structure', title: 'Update structure', step: revisePaySteps.step2 },
  { id: 'preview', title: 'Preview', step: revisePaySteps.step3 },
];

const steps = [
  { id: 'update-ctc', title: 'Update CTC', step: revisePaySteps.step1 },
  { id: 'preview', title: 'Preview', step: revisePaySteps.step3 },
];

export const Sidebar = () => {
  const { formData } = useFormWithProvider<ReviseSalaryFormData>();
  const { currentStep } = useWizardInfo();
  const { isM3S1Enabled, isM3S3Enabled } = useIsFeatureDisabledForRearch();

  const shouldShowUpdateStructureStep = isM3S3Enabled
    ? !formData.isCustomSalaryStructure
    : isM3S1Enabled;

  const stepsToRender = shouldShowUpdateStructureStep ? stepsWithMSS : steps;

  return (
    <Box
      minWidth="250px"
      display="flex"
      flexDirection="column"
      height="100%"
      justifyContent="space-between">
      <StepGroup orientation="vertical" size="medium">
        {stepsToRender.map((stepData) => (
          <StepItem
            key={stepData.id}
            title={stepData.title}
            marker={renderMarker(getStepMarker(currentStep, stepData.step))}
            isSelected={stepData.step === currentStep}
            isDisabled={stepData.step > currentStep}
          />
        ))}
      </StepGroup>
    </Box>
  );
};
